import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import dayjs from 'dayjs';
import { Swiper, SwiperSlide } from 'swiper/react';

import { programSnsList, vodList } from '@/network/apis/apiUri';
import useAxios from '@/network/useAxios';
import useContent from '@/localization/data_export';
import { secToTimeStr } from '../common/common_fnc';
import './css/tv_program_home.scss';

function TvProgramHome(props) {
  const { subLocation, setSubLocation, programData, title, detailData } = props;

  const location = useLocation();
  const anchorTitle = useContent(['global', 'anchor', 'title']);

  const programId = subLocation.split('/')[2];
  const [boardId, setBoardId] = useState();

  const [parameterData, setParameterData] = useState({
    program_id: programId,
    lan_code: props.mode,
    is_open_allow: true,
  });
  const [vodData, setVodData] = useState();

  const [snsImageList] = useAxios(programSnsList, [parameterData], parameterData, true);
  const [vodItem, vodRefetch] = useAxios(vodList, [], {}, false);
  const { data: vodListData } = vodItem;

  useEffect(() => {
    if (title.data) {
      let boardId;
      let filterVod = title.data?.item.filter((el) => el.is_open_allow === true && el.type === 'vod');
      if (filterVod.length !== 0) {
        boardId = filterVod[0].board_id;
      }
      if (boardId) {
        setBoardId(boardId);
      }
    }
  }, [title]);

  useEffect(() => {
    if (boardId) {
      vodRefetch({
        board_id: boardId,
        lan_code: props.mode,
        type: 'vod',
        start_reg_date: dayjs.tz().subtract(3, 'day').format('YYYY-MM-DD'),
        end_reg_date: dayjs.tz().format('YYYY-MM-DD'),
        page_info: {
          row_count: 10,
          number: 0,
        },
      });
    }
  }, [boardId]);

  useEffect(() => {
    setParameterData({
      program_id: subLocation.split('/')[2],
      lan_code: props.mode,
      is_Open_allow: true,
    });
  }, [subLocation]);

  useEffect(() => {
    setSubLocation(location.pathname);
  }, []);

  useEffect(() => {
    if (vodListData) {
      setVodData(vodListData.item);
    }
  }, [vodListData]);

  return (
    <>
      {!programData?.property?.is_teaser_allow && programData !== null && programData !== false ? (
        <section id="TvProgramHome" className="tvProgramHome">
          <div className="tvProgramHome_box head">
            <div className="head_titleBox">
              <div className="head_titleBox_top">
                <h2 className="title">{programData?.title[0].text} </h2>
                {!programData?.property?.is_onair && <p className="previus">PREVIOUS</p>}
              </div>
              {programData?.property?.is_onair &&
                programData?.property.schedule.map((v, i) => (
                  <div key={`$schedule_${i}`}>
                    {v?.start_time !== -1 && (
                      <>
                        {v?.week?.[0] !== '' && (
                          <p className="title_date">
                            {v.week.length === 7
                              ? 'EveryDay'
                              : v.week[0] === v.week.slice(-1)[0]
                              ? `${v.week[0]}`
                              : `${v.week[0]} ~ ${v.week.slice(-1)}`}
                          </p>
                        )}
                        <p className="title_time">{`${secToTimeStr(v?.start_time).substring(3)} ~ ${secToTimeStr(
                          v?.start_time + programData?.property.running_time
                        ).substring(3)} KST (Ch. KOREA)`}</p>
                      </>
                    )}
                  </div>
                ))}
            </div>
            <ul className="head_snsWrap">
              {snsImageList?.data?.item?.map((v, i) => {
                return (
                  v.is_open_allow && (
                    <li className="list" key={i}>
                      <a href={v.url} className="list_link" target="_blank" rel="noreferrer">
                        <img src={v.image.url} alt={v.sns_title} className="list_img" />
                      </a>
                    </li>
                  )
                );
              })}
            </ul>
          </div>
          <div className="tvProgramHome_box contentBox">
            <div className="contentBox_img">
              <div className="img-wrap">
                <img
                  src={`${
                    detailData
                      ? detailData?.item?.length === 0
                        ? programData?.image[0]?.url
                        : detailData?.item?.[0]?.image?.url
                      : programData?.image[0]?.url
                  }`}
                  alt={
                    detailData
                      ? detailData?.item?.length === 0
                        ? programData?.title?.[0]?.text
                        : detailData?.item?.[0]?.title
                      : programData?.title?.[0]?.text
                  }
                  className="img"
                  onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
                />
              </div>
            </div>
            <div className="contentBox_info">
              <h3 className="title">
                {detailData
                  ? detailData?.item.length === 0
                    ? programData?.title[0].text
                    : detailData?.item?.[0]?.title
                  : programData?.title[0].text}
              </h3>
              <p
                className="text style-scroll"
                dangerouslySetInnerHTML={{
                  __html: detailData
                    ? detailData?.item.length === 0
                      ? programData?.content[0].text?.replace(/(?:\r\n|\r|\n)/g, '<br />')
                      : detailData?.item?.[0]?.content?.replace(/(?:\r\n|\r|\n)/g, '<br />')
                    : programData?.content[0].text?.replace(/(?:\r\n|\r|\n)/g, '<br />'),
                }}
              ></p>
            </div>
          </div>
          {boardId && vodData && vodData.length !== 0 && (
            <div className="tvProgramHome_box slide">
              <div className="slide_titleBox">
                <h3 className="title">
                  Latest <em className="style-font">VOD</em>
                </h3>
              </div>
              <div className="slide_content">
                <Swiper
                  className="nav-style-1"
                  navigation={vodData?.length > 5}
                  slidesPerView={5}
                  loop={vodData?.length > 5}
                >
                  {vodData?.map((el) => (
                    <SwiperSlide key={el.board_item_id}>
                      <div className="latestSlide">
                        <Link
                          to={`${subLocation}/vod?id=${el.vod_id}&board=${boardId}&sort=vod`}
                          className="latestSlide_link"
                          title={anchorTitle}
                        >
                          <div className="latestSlide_img-wrap ico_play">
                            <img
                              src={el.image_url}
                              alt=""
                              className="latestSlide_img"
                              onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
                            />
                          </div>
                          <p className="latestSlide_text">{el.title}</p>
                        </Link>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          )}
          <div className="tvProgramHome_box foot">
            <div className="foot_textBox">
              <div className="foot_textBox_top">
                <h2 className="title">
                  {props.menu === 'ko' ? programData?.title?.[1].text : programData?.title?.[0].text}
                </h2>
                {!programData?.property?.is_onair && <p className="previus">PREVIOUS</p>}
              </div>

              {programData?.property?.is_onair &&
                programData?.property.schedule.map((v, i) => (
                  <div key={i}>
                    {v?.start_time !== -1 && (
                      <>
                        {v?.week?.[0] !== '' && (
                          <p className="title_date">
                            {v.week.length === 7
                              ? 'EveryDay'
                              : v.week[0] === v.week.slice(-1)[0]
                              ? `${v.week[0]}`
                              : `${v.week[0]} ~ ${v.week.slice(-1)}`}
                          </p>
                        )}
                        <p className="title_time">{`${secToTimeStr(v?.start_time).substring(3)} ~ ${secToTimeStr(
                          v?.start_time + programData?.property.running_time
                        ).substring(3)} KST`}</p>
                      </>
                    )}
                  </div>
                ))}
            </div>
            <div className="foot_snsBox">
              <ul className="snsBox_listWrap">
                {snsImageList?.data?.item?.map((v, i) => (
                  <li className="snsBox_listWrap_list" key={i}>
                    <a href={v.url} className="link" target="_blank" rel="noreferrer" title={anchorTitle}>
                      <img src={v.image.url} alt="" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
      ) : (
        <></>
      )}
    </>
  );
}

export default TvProgramHome;
